"use client";

import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle({ className = "" }: { className?: string }) {
  const [theme, setTheme] = useState<"dark" | "light">("light");
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    setTheme(document.documentElement.classList.contains("dark") ? "dark" : "light");
  }, []);

  function toggle() {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    const root = document.documentElement;
    if (next === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    try {
      localStorage.setItem("af-theme", next);
    } catch {}
  }

  const nextLabel = theme === "dark" ? "Цайвар горимд шилжих" : "Харанхуй горимд шилжих";

  return (
    <button
      onClick={toggle}
      aria-label={mounted ? nextLabel : "Загвар солих"}
      title={mounted ? nextLabel : "Загвар солих"}
      className={`flex h-11 w-11 items-center justify-center rounded-full border border-[var(--af-border)] text-[var(--af-muted)] transition hover:text-[var(--af-text)] ${className}`}
    >
      {mounted && theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}
